import type { UseFormRegister, UseFormWatch } from 'react-hook-form'
import { Checkbox, Select } from '@/components'

const HOUR_OPTIONS = Array.from({ length: 24 }, (_, h) => ({
    value: h,
    label: h === 0 ? '12:00 AM' : h < 12 ? `${h}:00 AM` : h === 12 ? '12:00 PM' : `${h - 12}:00 PM`,
}))

interface WorkspaceDailyLeadsSummaryFieldsProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    register: UseFormRegister<any>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    watch: UseFormWatch<any>
}

/**
 * The daily leads summary toggle and the send-at hour it reveals.
 *
 * The hour is only rendered while the summary is enabled, so a workspace that has the digest turned
 * off never collects a send time it would not use.
 */
export function WorkspaceDailyLeadsSummaryFields({ register, watch }: WorkspaceDailyLeadsSummaryFieldsProps) {
    return (
        <>
            <Checkbox
                label="Daily Leads Summary"
                description="Send a daily email to all workspace members summarizing new leads from the previous 24 hours. Emails are sent Monday–Friday mornings. No email is sent on days with zero leads."
                {...register('DailyLeadsSummaryEnabled')}
            />
            {watch('DailyLeadsSummaryEnabled') && (
                <div className="ml-7 flex items-center gap-2">
                    <Select
                        label="Send at"
                        labelSize="xs"
                        options={HOUR_OPTIONS}
                        placeholder="Select hour"
                        containerClassName="w-40"
                        {...register('DailyLeadsSummaryHour', { valueAsNumber: true })}
                    />
                    <span className="text-xs text-slate-500 dark:text-slate-400 mt-5">(workspace time zone)</span>
                </div>
            )}
        </>
    )
}
